import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Optional, Dropdown } from '@honda-canada/design-system-react';
import themeStyles from './SubCategoriesDropdown.styles';
const StyledSubCategoriesDropdown = themeStyles.apply(Dropdown, 'SubCategoriesDropdown');
const SubCategoriesDropdown = ({ defaultValue, selectedValue, setSelectedSubCategory, options, className = 'subCategoriesDropdown', }) => {
    if (!options)
        return null;
    return (_jsx(Optional, { when: !!selectedValue && setSelectedSubCategory, children: _jsx(StyledSubCategoriesDropdown, { variant: "alternateBordered", className: className, onChange: (value) => setSelectedSubCategory && setSelectedSubCategory(value), ariaLabel: selectedValue, styling: "secondary", options: options, defaultValue: defaultValue, value: selectedValue }) }));
};
export default SubCategoriesDropdown;
